import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import DynamicTestInstruction from '../../components/DynamicTestInstruction/DynamicTestInstruction';
import { GACategories, GAActions } from '../../analytics';
import { handleGAEvent } from '../../helperFunctions';
import { fetchTestInfo } from '../../store/actions/AssessmentActions';
import { startPracticeTest } from '../../store/actions/PracticeTestActions';

const PracticeTestInstructionsContainer = () => {
  const { t } = useTranslation('practice_tests');
  const dispatch = useDispatch();
  const { id } = useParams();

  useEffect(() => {
    dispatch(fetchTestInfo(id));
  }, [dispatch, id]);

  const handleStartTest = () => {
    dispatch(startPracticeTest(id));
  };

  const ctaButton = (
    <Button
      onClick={handleGAEvent(handleStartTest, GACategories.assessment, GAActions.startTest)}
      size="large"
      type="primary"
    >
      {t('practice_tests.test_result.start_test')}
    </Button>
  );

  return (
    <div
      style={{
        backgroundColor: '#002140',
        width: '100%',
        minHeight: '100vh',
        paddingTop: '150px',
      }}
    >
      {' '}
      <DynamicTestInstruction ctaButton={ctaButton} />{' '}
    </div>
  );
};

export default PracticeTestInstructionsContainer;
